import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
// Servizio per caricare la configurazione all'avvio dell'app
export class AppConfigService {
  static settings: any;

  constructor(private http: HttpClient) { }

  // Getter per accedere ai dati ovunque
  get config() {
    return AppConfigService.settings;
  }

  // Metodo generico per ottenere la configurazione tipizzata
  public static getConfig<T>(): T {
    return AppConfigService.settings as T;
  }

  // Questo metodo viene chiamato all'avvio
  public async loadConfig(): Promise<void> {
    if (!environment.configurationFiles?.length) {
      return Promise.resolve();
    }

    try {
      // Caricamento dei file di configurazione in sequenza
      for (const filePath of environment.configurationFiles) {
        const jsonFile = filePath.includes("/") ? filePath : `assets/configs/${filePath}`;

        const config = await lastValueFrom(this.http.get(jsonFile));
        AppConfigService.settings = { ...AppConfigService.settings, ...config };  // Merge delle configurazioni
      }
    } catch (error) {
      console.error('Errore nel caricamento della config:', error);
    }
  }
}
